<template>
	<div class="innerBox">
		<h1>PO Sparepart</h1>

		<panel class="border border-secondary" :noExpand="true">
			<template slot="header">
				<h4 class="panel-title">Filter</h4>
			</template>
			<div class="row outerBox filterBox">
				<div class="col row">
					<div class="col-md-3" :class="mobile ? 'pt-20' : ''">
						<label>Status</label>
						<MultiSelect
							v-model="filter.status"
							:options="options.status"
							:custom-label="
								(s) => s.charAt(0).toUpperCase() + s.slice(1)
							"
							placeholder="Pilih Status"
						></MultiSelect>
					</div>
					<div class="col-md-3" :class="mobile ? 'pt-20' : ''">
						<label>Dipesan Oleh</label>
						<MultiSelect
							v-model="filter.po_by"
							:options="options.po_by"
							:custom-label="
								(s) => s.charAt(0).toUpperCase() + s.slice(1)
							"
							placeholder="Pilih Pemesan"
						></MultiSelect>
					</div>
					<div class="col-md-3" :class="mobile ? 'pt-20' : ''">
						<label for="partshopCode">Tanggal</label>
						<flat-pickr
							v-model="selected.date"
							:config="rangeConfig"
							placeholder="Pilih Tanggal"
						></flat-pickr>
					</div>
					<div
						class="col-md-3"
						style="display: flex; flex-direction: column-reverse"
						:class="mobile ? 'pt-20' : ''"
					>
						<button
							type="button"
							class="btn btn-primary"
							style="height:38px; margin-bottom:0.5%"
							@click="generateData()"
						>
							Filter
						</button>
					</div>
				</div>
			</div>
		</panel>

		<!-- <vue-universal-table
        api_url="/api/v1/purchase-order"
        :fields="vue_universal_table.fields"
        :update="vue_universal_table.update"
        :special_buttons="vue_universal_table.special_buttons"
        :filter="filter"
        :disable_sort="true"
        :export_config="vue_universal_table.export_config"
      ></vue-universal-table> -->

		<table
			class="table text-center"
		>
			<thead>
				<th colspan="2">No.</th>
				<th colspan="2">Nomor Work Order</th>
				<th colspan="2">Nomor Polisi Mobil</th>
				<th colspan="1">Tipe Mobil</th>
				<th colspan="1">Nama Customer</th>
				<th><i class="fa fa-cog"></i></th>
			</thead>
			<tbody v-for="(dat, index) in data" :key="index">
				<tr>
					<td colspan="2">{{ index + 1 }}</td>
					<td colspan="2">{{ dat.work_order_code }}</td>
					<td colspan="2">{{ dat.no_pol }}</td>
					<td colspan="1">{{ dat.car_name }}</td>
					<td colspan="1">{{ dat.e }}</td>
					<td>
						<button
							v-if="!dat.show"
							class="btn btn-secondary"
							style="border-radius:20px"
							@click="showSpareparts(dat.work_order_code, index)"
						>
							<i class="fa fa-arrow-down"></i>
						</button>
						<button
							v-else
							class="btn btn-secondary"
							style="border-radius:20px"
							@click="
								$set(dat , 'show' , false);
								reloadTable = false;
								reloadTable = true;
							"
						>
							<i class="fa fa-arrow-up"></i>
						</button>
					</td>
				</tr>
				<template v-if="dat.sparepartList && dat.show">
					<tr style="background-color:#FFFFE0">
						<th>No.</th>
						<th>Sparepart Name</th>
						<th>Part Description</th>
						<th>Dipesan Oleh</th>
						<th>Status</th>
						<th>Dipesan Tanggal</th>
						<th colspan="3">Tanggal Kedatangan</th>
					</tr>
					<tr
						style="background-color:#FFFFE0"
						v-for="(sparepart, index) in dat.sparepartList"
						:key="index"
					>
						<td>{{ index + 1 }}</td>
						<td>{{ sparepart.sparepart_name }}</td>
						<td>{{ sparepart.part_description }}</td>
						<td v-if="sparepart.po_by == 'Insurance'">{{sparepart.insurance_company_name}} ({{ sparepart.po_by }})</td>
						<td v-else>{{ sparepart.po_by }}</td>
						<td>{{ sparepart.status }}</td>
						<td>{{ sparepart.created_at }}</td>
						<td colspan="3">{{ sparepart.time_of_arrival }}</td>
					</tr>
				</template>
			</tbody>
		</table>
		<div class="text-center mt-3 mb-3">
			<div class="spinner-border" role="status" style="width:5rem;height:5rem" v-if="loading">
				<span class="sr-only" >Loading...</span>
			</div>
		</div>
		<div class="row">
			<div :class="{ 'col-4': !mobile }"></div>
			<div style="padding: 20px" :class="mobile ? 'col' : 'col-4'">
				<nav>
					<ul class="pagination" style="justify-content:center">
						<li
							class="page-item"
							:class="{ disabled: config.current_page <= 1 }"
							@click="changePage(1)"
						>
							<span class="page-link">&laquo;</span>
						</li>
						<li
							class="page-item"
							:class="{ disabled: config.current_page <= 1 }"
							@click="changePage(5)"
						>
							<span class="page-link">&lsaquo;</span>
						</li>
						<li class="page-item pageNumber" style="cursor:pointer">
							<span class="page-link" style="color:black">
								<span style="font-weight: bold !important">{{
									config.last_page < 1
										? 0
										: config.current_page
								}}</span>
								of {{ config.last_page }}
							</span>
						</li>
						<li
							class="page-item"
							:class="{
								disabled:
									config.current_page >= config.last_page,
							}"
							@click="changePage(6)"
						>
							<span class="page-link">&rsaquo;</span>
						</li>
						<li
							class="page-item"
							:class="{
								disabled:
									config.current_page >= config.last_page,
							}"
							@click="changePage(10)"
						>
							<span class="page-link">&raquo;</span>
						</li>
					</ul>
				</nav>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			mobile: this.isMobile(),
			modal: {
				view: false,
			},
			rangeConfig: {
				mode: "range",
				altInput: true,
				altInputClass: "form-control input flatpickr-input w-100",
				animate: !this.isRTL(),
			},
			options: {
				status: ["pending", "arrived", "return"],
				po_by: ["insurance", "workshop"],
			},
			selected: {
				date: "",
			},
			data: null,
			filter: {
				status: "",
				po_by: "",
				type: "WO",
			},
			config: {
				current_page : 1,
				last_page : 1
			},
			vue_universal_table: {
				fields: [
					{
						title: "Work Order ID",
						variable: "work_order_code",
					},
					{
						title: "No Polisi Mobil",
						variable: "no_pol",
					},
					{
						title: "Nama Sparepart",
						variable: "sparepart_name",
					},
					{
						title: "Part Description",
						variable: "part_description",
					},
					{
						title: "Dipesan Oleh",
						variable: "po_by",
					},
					{
						title: "Status",
						variable: "status",
					},
					{
						title: "Dipesan Tanggal",
						variable: "created_at",
					},
					{
						title: "Tanggal Kedatangan",
						variable: "time_of_arrival",
					},
				],
				special_buttons: ["exportToExcel"],
				update: 0,
				export_config: {
					name: "Purchase Order Sparepart",
					type: "xlsx",
					all: true,
				},
			},
			dummyData: null,
			reloadTable: true,
			loading : false
		};
	},
	mounted() {
		this.generateData(null);
	},
	watch: {
		"selected.date"() {
			var date = this.selected.date.split(" to ");
			this.filter.start = date[0];
			this.filter.end = date[1];
		},
	},
	methods: {
		viewDetail(a) {
			console.log(JSON.parse(a).form_code);
			this.detailId = JSON.parse(a).form_code;
			this.modal.view = true;
		},
		showSpareparts(wo_code, index) {
			let data = this.data.find((x) => x.work_order_code == wo_code);
			if (data.sparepartList) {
				data.show = true;

				this.reloadTable = false;
				this.reloadTable = true;
				return;
			}

			let createQs = this.getQs(this.filter, true);
			createQs += `type=part&work_order_code=${wo_code}`;
			this.$http
				.get("/api/v1/purchase-order" + createQs)
				.then((resp) => {
					// data.show = true;
					this.$set(data , 'show' , true)
					data.sparepartList = resp.data.data;
					this.data[index] = data;
					console.log(this.data[index]);
					this.reloadTable = false;
					this.reloadTable = true;
				})
				.catch((err) => {
					console.log(err);
				});
		},
		generateData(numPage) {
			this.loading = true
			let filter = JSON.parse(JSON.stringify(this.filter));
			if (numPage) {
				filter.page = numPage;
			} else if (this.config) {
				filter.page = this.config.current_page;
			}

			let createQs = this.getQs(filter, false);
			this.$http
				.get("/api/v1/purchase-order" + createQs)
				.then((resp) => {
					this.data = resp.data.data;
					this.config = resp.data.meta;
					this.loading = false
				})
				.catch((err) => {
					console.log(err);
					this.loading = false
				});
		},
		changePage(opt) {
			//1 First, 5 previous, 6 next, 10 last
			switch (opt) {
				case 1: //laquo - First Page
					if (this.config.current_page - 1 > 0) {
						this.generateData(1);
					} else {
						this.newError("First Page Reached!");
					}
					break;
				case 5: //lsaquo - Previous Page
					if (this.config.current_page - 1 > 0) {
						this.generateData(this.config.current_page - 1);
					} else {
						this.newError("First Page Reached!");
					}
					break;
				case 6: //rsaquo - Next Page
					if (this.config.current_page + 1 <= this.config.last_page) {
						this.generateData(this.config.current_page + 1);
					} else {
						this.newError("Last Page Reached!");
					}
					break;
				case 10: //raquo - Last Page
					if (this.config.current_page + 1 <= this.config.last_page) {
						this.generateData(this.config.last_page);
					} else {
						this.newError("Last Page Reached!");
					}
					break;
				default:
					this.newError("Pagination Error, Read Documentation");
			}
		},
		getQs(filter, flag) {
			let stringUrl = "?";
			let keys = Object.keys(filter);

			for (var i = 0; i < keys.length; i++) {
				if (flag == true && keys[i] == "type") continue;

				if (!filter[keys[i]] || filter[keys[i]] == "") continue;
				stringUrl += `${keys[i]}=${filter[keys[i]]}&`;
			}

			return stringUrl;
		},
	},
};
</script>

<style scoped></style>
